import { render, staticRenderFns } from "./AdminDatasets.vue?vue&type=template&id=eb24dd3a&"
import script from "./AdminDatasets.vue?vue&type=script&lang=js&"
export * from "./AdminDatasets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports